import React from "react"
import { NavigationContext } from "./src/context/NavigationContext"
import "./src/styles/global.less"

export const wrapPageElement = ({ element, props }) => (
    <NavigationContext.Provider value={props.pageContext.navigationContext}>
        {element}
    </NavigationContext.Provider>
)